import { render } from "./restartRecordList.vue?vue&type=template&id=796b3415&scoped=true"
import script from "./restartRecordList.vue?vue&type=script&lang=js"
export * from "./restartRecordList.vue?vue&type=script&lang=js"

import "./restartRecordList.vue?vue&type=style&index=0&id=796b3415&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-796b3415"

export default script